<div class="wiz-card" role="main" [attr.aria-label]="'Asistente: ' + wizardTitle">

    <!-- ── Loading overlay while stores initialize ───────────────────── -->
    @if (isInitializing()) {
      <div class="wiz-loading" role="status" aria-live="polite" aria-label="Cargando datos...">
        <span class="wiz-loading-spinner" aria-hidden="true"></span>
        <span>Cargando datos del cliente...</span>
      </div>
    }

    @if (!isInitializing()) {

    <!-- ── Header ─────────────────────────────────────────────────────── -->
    <header class="wiz-header">
      <div class="wiz-header-info">
        <div class="wiz-header-labels" style="flex-direction: row; display: flex; align-items: baseline;">
          <h2 class="wiz-categoria-label">{{ categoriaLabel }}</h2>
          @if (subtipoLabel) {
            <h2 class="wiz-categoria-label">: {{ subtipoLabel }}</h2>
          }
        </div>
        <!-- <span class="wiz-step-counter">Paso {{ currentStep() + 1 }} de {{ totalSteps() }}</span> -->
      </div>
      <!-- <button
        type="button"
        class="wiz-close-btn"
        (click)="cancel.emit()"
        aria-label="Cerrar asistente"
      >
        <fa-icon [icon]="faXmark" aria-hidden="true"></fa-icon>
      </button> -->
    </header>

    <!-- ── Step indicator ─────────────────────────────────────────────── -->
    <nav class="wiz-stepper" aria-label="Pasos del asistente">
      @for (step of steps(); track step.key; let i = $index) {
        <div
          class="wiz-step"
          [class.is-completed]="isStepCompleted(i)"
          [class.is-active]="isStepActive(i)"
        >
          <button
            type="button"
            class="wiz-bubble"
            (click)="goToStep(i)"
            [attr.aria-label]="'Ir al paso ' + (i + 1) + ': ' + step.label"
            [attr.aria-current]="isStepActive(i) ? 'step' : null"
            [disabled]="i > currentStep()"
          >
            @if (isStepCompleted(i)) {
              <fa-icon [icon]="faCheck" aria-hidden="true"></fa-icon>
            } @else {
              {{ i + 1 }}
            }
          </button>
          <span class="wiz-step-label">{{ step.label }}</span>
        </div>

        @if (i < steps().length - 1) {
          <div
            class="wiz-connector"
            [class.is-done]="isStepCompleted(i + 1) || isStepActive(i + 1)"
          ></div>
        }
      }
    </nav>

    <!-- ── Step content ────────────────────────────────────────────────── -->
    <div class="wiz-body">

      <!-- ── Paso 0: metadata de la operación ──────────────────────────── -->
      <div [formGroup]="metaForm" class="wiz-meta-form"
           [hidden]="currentStepKey() !== 'escritura_meta' && !isResumen()">
          <h3 class="wiz-section-title">Datos de escritura</h3>
          <div class="columns is-multiline">

            <div class="column is-4 form-container">
              <label class="label" for="wiz-fecha">Fecha de escritura</label>
              <p-calendar
                inputId="wiz-fecha"
                formControlName="fechaEscritura"
                dateFormat="dd/mm/yy"
                dataType="string"
                [showIcon]="true"
                class="search-input"
                placeholder="dd/mm/aaaa"
              ></p-calendar>
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-concepto">Concepto de escritura</label>
              <input
                id="wiz-concepto"
                class="search-input"
                type="text"
                pInputText
                formControlName="conceptoEscritura"
                placeholder="Concepto de la escritura"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-notario">Notario</label>
              <input
                id="wiz-notario"
                class="search-input"
                type="text"
                pInputText
                formControlName="notario"
                placeholder="Nombre del notario"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-protocolo">Protocolo</label>
              <input
                id="wiz-protocolo"
                class="search-input"
                type="text"
                pInputText
                formControlName="protocolo"
                placeholder="Nº de protocolo"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-irus">IRUS</label>
              <input
                id="wiz-irus"
                class="search-input"
                type="text"
                pInputText
                formControlName="irus"
                placeholder="Código IRUS"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-prov-rm">Provincia RM</label>
              <p-dropdown
                inputId="wiz-prov-rm"
                [options]="provinceOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="provinciaRM"
                placeholder="Seleccionar provincia..."
                [filter]="true"
                filterPlaceholder="Buscar..."
                appendTo="body"
                [baseZIndex]="3000"
                class="search-input"
              ></p-dropdown>
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-fecha-inscripcion">Fecha de inscripción</label>
              <p-calendar
                inputId="wiz-fecha-inscripcion"
                formControlName="fechaInscripcion"
                dateFormat="dd/mm/yy"
                dataType="string"
                [showIcon]="true"
                class="search-input"
                placeholder="dd/mm/aaaa"
              ></p-calendar>
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-tomo">Tomo</label>
              <input
                id="wiz-tomo"
                class="search-input"
                type="text"
                pInputText
                formControlName="tomo"
                placeholder="Tomo"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-folio">Folio</label>
              <input
                id="wiz-folio"
                class="search-input"
                type="text"
                pInputText
                formControlName="folio"
                placeholder="Folio"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-hoja">Hoja</label>
              <input
                id="wiz-hoja"
                class="search-input"
                type="text"
                pInputText
                formControlName="hoja"
                placeholder="Hoja"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-seccion">Sección</label>
              <input
                id="wiz-seccion"
                class="search-input"
                type="text"
                pInputText
                formControlName="seccion"
                placeholder="Sección"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-libro">Libro</label>
              <input
                id="wiz-libro"
                class="search-input"
                type="text"
                pInputText
                formControlName="libro"
                placeholder="Libro"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-num-inscripcion">Nº inscripción</label>
              <input
                id="wiz-num-inscripcion"
                class="search-input"
                type="text"
                pInputText
                formControlName="numInscripcion"
                placeholder="Nº inscripción"
              />
            </div>

            <div class="column is-12 form-container">
              <label class="label" for="wiz-obs">Observaciones</label>
              <textarea
                id="wiz-obs"
                pInputTextarea
                [autoResize]="true"
                class="search-input"
                formControlName="observaciones"
                rows="3"
                placeholder="Observaciones"
              ></textarea>
            </div>

          </div>

          <!-- Documentos -->
          <h3 class="wiz-section-title" style="margin-top: 1.5rem;">Documentos</h3>
          <div class="wiz-upload-area">
            <label class="wiz-upload-label" for="wiz-file-input">
              <fa-icon [icon]="faUpload" aria-hidden="true"></fa-icon>
              <span>Adjuntar documentos de la escritura</span>
              <input
                id="wiz-file-input"
                type="file"
                multiple
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                class="wiz-file-input"
                (change)="onFileSelect($event)"
                (cancel)="$event.stopPropagation()"
                aria-label="Seleccionar documentos"
              />
            </label>

            @if (attachedFiles.length > 0) {
              <ul class="wiz-file-list" role="list" aria-label="Documentos adjuntos">
                @for (file of attachedFiles; track file.name; let i = $index) {
                  <li class="wiz-file-item">
                    <fa-icon [icon]="faFile" aria-hidden="true"></fa-icon>
                    <button
                      type="button"
                      class="wiz-file-name wiz-file-link"
                      (click)="openLocalFile(file)"
                      [title]="'Abrir ' + file.name"
                    >{{ file.name }}</button>
                    <span class="wiz-file-size">{{ (file.size / 1024).toFixed(1) }} KB</span>
                    <button
                      type="button"
                      class="wiz-file-remove"
                      (click)="removeFile(i)"
                      [attr.aria-label]="'Eliminar ' + file.name"
                    >
                      <fa-icon [icon]="faTrash" aria-hidden="true"></fa-icon>
                    </button>
                  </li>
                }
              </ul>
            }

            @if (savedDocuments.length > 0) {
              <p class="wiz-field-hint" style="margin-top: 0.75rem;">Documentos ya guardados</p>
              <ul class="wiz-file-list" role="list" aria-label="Documentos ya guardados">
                @for (doc of savedDocuments; track doc.id) {
                  <li class="wiz-file-item">
                    <fa-icon [icon]="faFile" aria-hidden="true"></fa-icon>
                    <button
                      type="button"
                      class="wiz-file-name wiz-file-link"
                      (click)="openSavedDocument(doc)"
                      [title]="'Abrir ' + doc.originalName"
                    >{{ doc.originalName }}</button>
                    <span class="wiz-file-size">{{ (doc.size / 1024).toFixed(1) }} KB</span>
                  </li>
                }
              </ul>
            }
          </div>

        </div>

      <!-- ── Cross-tab: Denominación social ────────────────────────────── -->
      @if (currentStepKey() === 'step_denominacion' || (isResumen() && hasStep('step_denominacion'))) {
        <div class="wiz-crosstab-step">

          @if (tabAfectada) {
            <div class="wiz-crosstab-note" role="note">
              <span class="wiz-crosstab-note-pill">Pestaña {{ tabAfectada.label }}</span>
              <span class="wiz-crosstab-note-text">{{ tabAfectada.accion }}</span>
            </div>
          }

          <h3 class="wiz-section-title">Razón social</h3>

          <div [formGroup]="crossTabForm" class="columns is-multiline">

            <div class="column is-12 form-container">
              <label class="label" for="wiz-razon-social">Razón social</label>
              <input
                id="wiz-razon-social"
                class="search-input"
                type="text"
                pInputText
                formControlName="nuevaRazonSocial"
                placeholder="Modifica la denominación social..."
                style="text-transform: uppercase"
              />
            </div>

          </div>
        </div>
      }

      <!-- ── Cross-tab: Domicilio social ───────────────────────────────── -->
      @if (currentStepKey() === 'step_domicilio' || (isResumen() && hasStep('step_domicilio'))) {
        <div class="wiz-crosstab-step">

          @if (tabAfectada) {
            <div class="wiz-crosstab-note" role="note">
              <span class="wiz-crosstab-note-pill">Pestaña {{ tabAfectada.label }}</span>
              <span class="wiz-crosstab-note-text">{{ tabAfectada.accion }}</span>
            </div>
          }

          <h3 class="wiz-section-title">Nuevo domicilio social</h3>

          <div [formGroup]="crossTabForm" class="columns is-multiline">

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-tipo">Tipo de domicilio</label>
              <p-dropdown
                inputId="wiz-dom-tipo"
                [options]="domicileOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="tipo"
                appendTo="body"
                [baseZIndex]="3000"
                class="search-input"
              ></p-dropdown>
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-fecha">Fecha de alta</label>
              <p-calendar
                inputId="wiz-dom-fecha"
                formControlName="fechaAlta"
                dateFormat="dd/mm/yy"
                dataType="string"
                [showIcon]="true"
                class="search-input"
                placeholder="dd/mm/aaaa"
              ></p-calendar>
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-siglas">Siglas</label>
              <input
                id="wiz-dom-siglas"
                class="search-input"
                type="text"
                pInputText
                formControlName="siglas"
                placeholder="Siglas del edificio"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-via">Vía pública</label>
              <input
                id="wiz-dom-via"
                class="search-input"
                type="text"
                pInputText
                formControlName="viapublica"
                placeholder="Nombre de la vía"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-num">Número de vía</label>
              <input
                id="wiz-dom-num"
                class="search-input"
                type="text"
                pInputText
                formControlName="numero"
                placeholder="Nº"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-esc">Escalera</label>
              <input
                id="wiz-dom-esc"
                class="search-input"
                type="text"
                pInputText
                formControlName="escalera"
                placeholder="Esc."
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-piso">Piso</label>
              <input
                id="wiz-dom-piso"
                class="search-input"
                type="text"
                pInputText
                formControlName="piso"
                placeholder="Piso"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-puerta">Puerta</label>
              <input
                id="wiz-dom-puerta"
                class="search-input"
                type="text"
                pInputText
                formControlName="puerta"
                placeholder="Pta."
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-muni">Municipio</label>
              <input
                id="wiz-dom-muni"
                class="search-input"
                type="text"
                pInputText
                formControlName="municipio"
                placeholder="Municipio"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-cp">Código postal</label>
              <input
                id="wiz-dom-cp"
                class="search-input"
                type="text"
                pInputText
                formControlName="cp"
                placeholder="CP"
              />
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-prov">Provincia</label>
              <p-dropdown
                inputId="wiz-dom-prov"
                [options]="provinceOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="provincia"
                placeholder="Seleccionar provincia..."
                [filter]="true"
                filterPlaceholder="Buscar..."
                appendTo="body"
                [baseZIndex]="3000"
                class="search-input"
              ></p-dropdown>
            </div>

            <div class="column is-4 form-container">
              <label class="label" for="wiz-dom-ref">Referencia catastral</label>
              <input
                id="wiz-dom-ref"
                class="search-input"
                type="text"
                pInputText
                formControlName="refCatastral"
                placeholder="Ref. catastral"
              />
            </div>

            <div class="column is-12 form-container">
              <label class="label" for="wiz-dom-obs">Observaciones</label>
              <textarea
                id="wiz-dom-obs"
                pInputTextarea
                [autoResize]="true"
                class="search-input"
                formControlName="observaciones"
                rows="3"
                placeholder="Observaciones"
              ></textarea>
            </div>

          </div>
        </div>
      }

      <!-- ── Cross-tab: Articulado de estatutos ────────────────────────── -->
      @if (currentStepKey() === 'step_articulado' || (isResumen() && hasStep('step_articulado'))) {
        <div class="wiz-crosstab-step">

          <h3 class="wiz-section-title">Articulado de estatutos</h3>
          <p class="wiz-crosstab-intro">Indica los artículos modificados y describe los cambios introducidos en los estatutos.</p>

          <div [formGroup]="crossTabForm" class="columns is-multiline">

            <div class="column is-12 form-container">
              <label class="label" for="wiz-art-articulos">Artículos modificados</label>
              <input
                id="wiz-art-articulos"
                class="search-input"
                type="text"
                pInputText
                formControlName="articulosModificados"
                placeholder="P.ej.: Art. 5, Art. 12, Art. 20..."
              />
            </div>

            <div class="column is-12 form-container">
              <label class="label" for="wiz-art-desc">Descripción del cambio</label>
              <textarea
                id="wiz-art-desc"
                pInputTextarea
                [autoResize]="true"
                class="search-input"
                formControlName="descripcionCambio"
                rows="6"
                placeholder="Describe brevemente el contenido de la modificación estatutaria..."
              ></textarea>
            </div>

          </div>
        </div>
      }

      <!-- ── Ampliación: Tipo de ampliación ───────────────────────────── -->
      @if (currentStepKey() === 'step_ampliacion_tipo' || (isResumen() && hasStep('step_ampliacion_tipo'))) {
        <div class="wiz-crosstab-step">
          <h3 class="wiz-section-title">Tipo de ampliación</h3>

          <div [formGroup]="ampTipoForm" class="columns is-multiline">

            <div class="column is-6 form-container">
              <label class="label" for="wiz-amp-tipo">Tipo de ampliación</label>
              <p-dropdown
                inputId="wiz-amp-tipo"
                [options]="tipoAmpliacionOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="tipoAmpliacion"
                placeholder="Seleccionar tipo..."
                appendTo="body"
                [baseZIndex]="3000"
                class="search-input"
                (onChange)="onTipoAmpliacionChange($event.value)"
              ></p-dropdown>
            </div>

            <div class="column is-6"></div>

            @if (selectedTipoAmpliacion() === 'no_dineraria') {
              <div class="column is-12 form-container">
                <label class="label" for="wiz-amp-aportaciones">Detalle aportaciones</label>
                <textarea
                  id="wiz-amp-aportaciones"
                  pInputTextarea
                  [autoResize]="true"
                  class="search-input"
                  formControlName="detalleAportaciones"
                  rows="4"
                  placeholder="Describa las aportaciones no dinerarias..."
                ></textarea>
              </div>
            }

            @if (selectedTipoAmpliacion() === 'canje_valores') {
              <div class="column is-12 form-container">
                <label class="label" for="wiz-amp-canje">Régimen especial Canje de Valores</label>
                <textarea
                  id="wiz-amp-canje"
                  pInputTextarea
                  [autoResize]="true"
                  class="search-input"
                  formControlName="detalleCanje"
                  rows="4"
                  placeholder="Detalle del régimen especial de canje de valores..."
                ></textarea>
              </div>
            }

          </div>
        </div>
      }

      <!-- ── Ampliación: Datos de la ampliación ─────────────────────────── -->
      @if (currentStepKey() === 'step_ampliacion_datos' || (isResumen() && hasStep('step_ampliacion_datos'))) {
        <div class="wiz-crosstab-step">
          <h3 class="wiz-section-title">Datos de la ampliación</h3>

          <div [formGroup]="ampDatosForm" class="columns is-multiline">

            <div class="column is-6 form-container">
              <label class="label" for="wiz-amp-modo">Modo de ampliación</label>
              <p-dropdown
                inputId="wiz-amp-modo"
                [options]="modoAmpliacionOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="modoAmpliacion"
                placeholder="Seleccionar modo..."
                appendTo="body"
                [baseZIndex]="3000"
                class="search-input"
                (onChange)="onModoAmpliacionChange($event.value)"
              ></p-dropdown>
            </div>

            <div class="column is-6"></div>

            <!-- Ampliación VN -->
            @if (selectedModoAmpliacion() === 'ampliacion_vn') {
              <div class="column is-12">
                <h4 class="wiz-subsection-title">Ampliación Valor Nominal</h4>
              </div>

              <div class="column is-4 form-container">
                <label class="label" for="wiz-vn-serie">Serie</label>
                <p-dropdown
                  inputId="wiz-vn-serie"
                  [options]="seriesOptions()"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="vnSerie"
                  placeholder="Seleccionar serie..."
                  appendTo="body"
                  [baseZIndex]="3000"
                  class="search-input"
                  (onChange)="onSerieChange('vnSerie', $event.value)"
                ></p-dropdown>
              </div>

              <div class="column is-4 form-container">
                <label class="label" for="wiz-vn-importe">Importe ampliado</label>
                <input
                  id="wiz-vn-importe"
                  class="search-input"
                  type="text"
                  pInputText
                  formControlName="vnImporteAmpliado"
                  (input)="recalcNuevoVnAmpliacion()"
                  placeholder="Ej: 1,50 €"
                />
                <small class="wiz-field-hint">Diferencia entre el VN antiguo y el nuevo</small>
              </div>

              <div class="column is-4 form-container">
                <label class="label" for="wiz-vn-nuevo">Nuevo VN</label>
                <input
                  id="wiz-vn-nuevo"
                  class="search-input"
                  type="text"
                  pInputText
                  formControlName="vnNuevoVN"
                  placeholder="Ej: 2,50 €"
                />
                <small class="wiz-field-hint">Valor nominal resultante</small>
              </div>

              @for (extra of vnExtras.controls; track extra; let i = $index) {
                <ng-container [formGroup]="$any(extra)">
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-vn-serie-x' + i">Serie</label>
                    <p-dropdown
                      [inputId]="'wiz-vn-serie-x' + i"
                      [options]="seriesOptions()"
                      optionLabel="label"
                      optionValue="value"
                      formControlName="serie"
                      placeholder="Seleccionar serie..."
                      appendTo="body"
                      [baseZIndex]="3000"
                      class="search-input"
                      (onChange)="onVnExtraSerieChange(i, $event.value)"
                    ></p-dropdown>
                  </div>
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-vn-importe-x' + i">Importe ampliado</label>
                    <input
                      [id]="'wiz-vn-importe-x' + i"
                      class="search-input"
                      type="text"
                      pInputText
                      formControlName="importe"
                      (input)="recalcNuevoVnExtra(i)"
                      placeholder="Ej: 1,50 €"
                    />
                  </div>
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-vn-nuevo-x' + i">Nuevo VN</label>
                    <div class="is-flex is-align-items-center">
                      <input
                        [id]="'wiz-vn-nuevo-x' + i"
                        class="search-input"
                        type="text"
                        pInputText
                        formControlName="nuevoVN"
                        placeholder="Ej: 2,50 €"
                      />
                      <button
                        type="button"
                        class="wiz-btn-icon wiz-btn-icon--danger"
                        (click)="removeVnExtra(i)"
                        [attr.aria-label]="'Eliminar serie ' + (i + 2)"
                      >
                        <fa-icon [icon]="faTrash"></fa-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              }

              <div class="column is-12">
                <button type="button" class="wiz-btn-text" (click)="addVnExtra()">+ Añadir otra serie</button>
              </div>
            }

            <!-- Ampliación acciones -->
            @if (selectedModoAmpliacion() === 'ampliacion_acciones') {
              <div class="column is-12">
                <h4 class="wiz-subsection-title">Ampliación acciones</h4>
              </div>

              <div class="column is-4 form-container">
                <label class="label" for="wiz-acc-serie">Serie</label>
                <p-dropdown
                  inputId="wiz-acc-serie"
                  [options]="seriesOptions()"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="accSerie"
                  placeholder="Seleccionar serie..."
                  appendTo="body"
                  [baseZIndex]="3000"
                  class="search-input"
                  (onChange)="onAccSerieChange()"
                ></p-dropdown>
              </div>

              @if (accNuevaSerieActiva) {
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-acc-nueva-nombre">Nombre de la nueva serie</label>
                  <input
                    id="wiz-acc-nueva-nombre"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="accNuevaSerieNombre"
                    placeholder="Ej: SERIE B"
                  />
                </div>
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-acc-nueva-vn">Valor nominal por acción</label>
                  <input
                    id="wiz-acc-nueva-vn"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="accNuevaSerieVN"
                    placeholder="Ej: 1,00 €"
                  />
                </div>
              }

              <div class="column is-4 form-container">
                <label class="label" for="wiz-acc-nuevas">Nuevas acciones</label>
                <input
                  id="wiz-acc-nuevas"
                  class="search-input"
                  type="text"
                  pInputText
                  formControlName="accNuevasAcciones"
                  placeholder="Ej: 5"
                />
                <small class="wiz-field-hint">Número de nuevas acciones a emitir</small>
              </div>

              <div class="column is-4 form-container">
                <label class="label" for="wiz-acc-desde">De la</label>
                <input
                  id="wiz-acc-desde"
                  class="search-input"
                  type="text"
                  pInputText
                  formControlName="accDesde"
                  placeholder="Nº inicio"
                />
              </div>

              <div class="column is-4 form-container">
                <label class="label" for="wiz-acc-hasta">A la</label>
                <input
                  id="wiz-acc-hasta"
                  class="search-input"
                  type="text"
                  pInputText
                  formControlName="accHasta"
                  placeholder="Nº fin"
                />
              </div>

              @for (extra of accExtras.controls; track extra; let i = $index) {
                <ng-container [formGroup]="$any(extra)">
                  <div class="column is-12 p-0"></div>
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-acc-serie-x' + i">Serie</label>
                    <p-dropdown
                      [inputId]="'wiz-acc-serie-x' + i"
                      [options]="seriesOptions()"
                      optionLabel="label"
                      optionValue="value"
                      formControlName="serie"
                      placeholder="Seleccionar serie..."
                      appendTo="body"
                      [baseZIndex]="3000"
                      class="search-input"
                      (onChange)="onAccExtraSerieChange(i, $event.value)"
                    ></p-dropdown>
                  </div>
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-acc-nuevas-x' + i">Nuevas acciones</label>
                    <input [id]="'wiz-acc-nuevas-x' + i" class="search-input" type="text" pInputText formControlName="nuevas" placeholder="Ej: 5" />
                  </div>
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-acc-desde-x' + i">De la</label>
                    <input [id]="'wiz-acc-desde-x' + i" class="search-input" type="text" pInputText formControlName="desde" placeholder="Nº inicio" />
                  </div>
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-acc-hasta-x' + i">A la</label>
                    <div class="is-flex is-align-items-center">
                      <input [id]="'wiz-acc-hasta-x' + i" class="search-input" type="text" pInputText formControlName="hasta" placeholder="Nº fin" />
                      <button
                        type="button"
                        class="wiz-btn-icon wiz-btn-icon--danger"
                        (click)="removeAccExtra(i)"
                        [attr.aria-label]="'Eliminar serie ' + (i + 2)"
                      >
                        <fa-icon [icon]="faTrash"></fa-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              }

              <div class="column is-12">
                <button type="button" class="wiz-btn-text" (click)="addAccExtra()">+ Añadir otra serie</button>
              </div>
            }

          </div>
        </div>
        <!-- Hidden capital component so its serie-creation modal is available on this step -->
        <div class="wiz-capital-modal-host">
          <app-constitution-capital-series-section [clientId]="clientId" [deferPersistence]="true" (seriesChanged)="syncSociosWithCapital()"></app-constitution-capital-series-section>
        </div>
      }

      <!-- ── Reducción de capital: Tipos de reducción ───────────────────── -->
      @if (currentStepKey() === 'step_reduccion_tipos' || (isResumen() && hasStep('step_reduccion_tipos'))) {
        <div class="wiz-crosstab-step">
          <h3 class="wiz-section-title">Tipos de reducción</h3>

          @for (entry of reduccionEntries.controls; track entry; let i = $index) {
            <div class="wiz-reduccion-entry" [formGroup]="$any(entry)">
              <div class="wiz-reduccion-entry__header">
                <h4 class="wiz-subsection-title">Reducción {{ i + 1 }}</h4>
                @if (reduccionEntries.length > 1) {
                  <button
                    type="button"
                    class="wiz-btn-icon wiz-btn-icon--danger"
                    (click)="removeReduccionEntry(i)"
                    [attr.aria-label]="'Eliminar reducción ' + (i + 1)"
                  >
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                }
              </div>

              <div class="columns is-multiline">
                <div class="column is-6 form-container">
                  <label class="label" [attr.for]="'wiz-red-tipo-' + i">Tipo de reducción</label>
                  <p-dropdown
                    [inputId]="'wiz-red-tipo-' + i"
                    [options]="tipoReduccionOptions"
                    optionLabel="label"
                    optionValue="value"
                    formControlName="tipoReduccion"
                    placeholder="Seleccionar tipo..."
                    appendTo="body"
                    [baseZIndex]="3000"
                    class="search-input"
                  ></p-dropdown>
                </div>

                <div class="column is-6"></div>

                <div class="column is-4 form-container">
                  <label class="label" [attr.for]="'wiz-red-serie-' + i">Serie</label>
                  <p-dropdown
                    [inputId]="'wiz-red-serie-' + i"
                    [options]="reduccionSeriesOptions()"
                    optionLabel="label"
                    optionValue="value"
                    formControlName="serie"
                    placeholder="Seleccionar serie..."
                    appendTo="body"
                    [baseZIndex]="3000"
                    class="search-input"
                    (onChange)="onReduccionSerieChange(i, $event.value)"
                  ></p-dropdown>
                </div>

                <div class="column is-8"></div>

                @if (reduccionEntries.at(i).get('tipoReduccion')?.value === 'disminucion_vn') {
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-red-importe-' + i">Importe reducido</label>
                    <input
                      [id]="'wiz-red-importe-' + i"
                      class="search-input"
                      type="text"
                      pInputText
                      formControlName="importeReducido"
                      (input)="recalcNuevoVnReduccion(i)"
                      placeholder="Ej: 0,30 €"
                    />
                    <small class="wiz-field-hint">Diferencia entre el VN antiguo y el nuevo</small>
                  </div>

                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-red-nuevovn-' + i">Nuevo VN</label>
                    <input
                      [id]="'wiz-red-nuevovn-' + i"
                      class="search-input"
                      type="text"
                      pInputText
                      formControlName="nuevoVN"
                      placeholder="Ej: 0,70 €"
                    />
                    <small class="wiz-field-hint">Valor nominal resultante</small>
                  </div>
                }

                @if (reduccionEntries.at(i).get('tipoReduccion')?.value === 'amortizacion_acciones') {
                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-red-numamort-' + i">Nº acciones amortizadas</label>
                    <input
                      [id]="'wiz-red-numamort-' + i"
                      class="search-input"
                      type="text"
                      pInputText
                      readonly
                      [value]="amortizacionCount(i) || ''"
                      placeholder="Se calcula de la numeración"
                    />
                    <small class="wiz-field-hint">Calculado a partir de la numeración amortizada</small>
                  </div>

                  <div class="column is-4 form-container">
                    <label class="label" [attr.for]="'wiz-red-baja-' + i">Fecha de baja de la serie</label>
                    <p-calendar
                      [inputId]="'wiz-red-baja-' + i"
                      formControlName="fechaBaja"
                      dateFormat="dd/mm/yy"
                      dataType="string"
                      [showIcon]="true"
                      appendTo="body"
                      [baseZIndex]="3000"
                      class="search-input"
                      placeholder="dd/mm/aaaa"
                    ></p-calendar>
                    <small class="wiz-field-hint">Si se informa sin numeración, la serie se elimina del capital social</small>
                  </div>

                  <div class="column is-12">
                    <label class="label">Numeración acciones amortizadas @if (!reduccionEntries.at(i).get('fechaBaja')?.value) { * }</label>
                    @for (rango of getReduccionRangos(i).controls; track rango; let j = $index) {
                      <div class="wiz-rango-row" [formGroup]="$any(rango)">
                        <span class="wiz-rango-row__label">De la</span>
                        <input
                          class="search-input wiz-rango-row__input"
                          type="text"
                          pInputText
                          formControlName="desde"
                          placeholder="Nº inicio"
                        />
                        <span class="wiz-rango-row__label">a la</span>
                        <input
                          class="search-input wiz-rango-row__input"
                          type="text"
                          pInputText
                          formControlName="hasta"
                          placeholder="Nº fin"
                        />
                        @if (getReduccionRangos(i).length > 1) {
                          <button
                            type="button"
                            class="wiz-btn-icon wiz-btn-icon--danger"
                            (click)="removeReduccionRango(i, j)"
                            [attr.aria-label]="'Eliminar rango ' + (j + 1)"
                          >
                            <fa-icon [icon]="faTrash"></fa-icon>
                          </button>
                        }
                      </div>
                    }
                    <button
                      type="button"
                      class="wiz-btn-text"
                      (click)="addReduccionRango(i)"
                    >
                      + Añadir rango
                    </button>
                  </div>
                }
              </div>
            </div>
          }

          <button
            type="button"
            class="wiz-btn-text"
            (click)="addReduccionEntry()"
          >
            + Añadir tipo de reducción
          </button>
        </div>
        <!-- Hidden capital component for serie-creation modal -->
        <div class="wiz-capital-modal-host">
          <app-constitution-capital-series-section [clientId]="clientId" [deferPersistence]="true" (seriesChanged)="syncSociosWithCapital()"></app-constitution-capital-series-section>
        </div>
      }

      <!-- ── Contrasplit ────────────────────────────────────────────────── -->
      @if (currentStepKey() === 'step_contrasplit' || (isResumen() && hasStep('step_contrasplit'))) {
        <div class="wiz-crosstab-step">
          <h3 class="wiz-section-title">Contrasplit</h3>

          <div [formGroup]="$any(reduccionEntries.at(0))">
            <div class="columns is-multiline">
              <div class="column is-6 form-container">
                <label class="label" for="wiz-cs-tipo">Tipo de contrasplit</label>
                <p-dropdown
                  inputId="wiz-cs-tipo"
                  [options]="tipoContrasplitOptions"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="tipoReduccion"
                  placeholder="Seleccionar tipo..."
                  appendTo="body"
                  [baseZIndex]="3000"
                  class="search-input"
                ></p-dropdown>
              </div>

              <div class="column is-6"></div>

              <div class="column is-4 form-container">
                <label class="label" for="wiz-cs-serie">Serie</label>
                <p-dropdown
                  inputId="wiz-cs-serie"
                  [options]="reduccionSeriesOptions()"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="serie"
                  placeholder="Seleccionar serie..."
                  appendTo="body"
                  [baseZIndex]="3000"
                  class="search-input"
                  (onChange)="onReduccionSerieChange(0, $event.value)"
                ></p-dropdown>
              </div>

              <div class="column is-8"></div>

              <!-- Ampliación VN -->
              @if (reduccionEntries.at(0).get('tipoReduccion')?.value === 'disminucion_vn') {
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-cs-importe">Importe ampliado</label>
                  <input
                    id="wiz-cs-importe"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="importeReducido"
                    (input)="recalcNuevoVnReduccion(0)"
                    placeholder="Ej: 1,50 €"
                  />
                  <small class="wiz-field-hint">Diferencia entre el VN antiguo y el nuevo. Ej: si era 1€ y pasa a 2,50€, informar 1,50€</small>
                </div>

                <div class="column is-4 form-container">
                  <label class="label" for="wiz-cs-nuevovn">Nuevo VN</label>
                  <input
                    id="wiz-cs-nuevovn"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="nuevoVN"
                    placeholder="Ej: 2,50 €"
                  />
                  <small class="wiz-field-hint">Valor nominal resultante. Ej: si era 1€ y pasa a 2,50€, informar 2,50€</small>
                </div>
              }

              <!-- Amortización acciones -->
              @if (reduccionEntries.at(0).get('tipoReduccion')?.value === 'amortizacion_acciones') {
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-cs-numamort">Nº acciones amortizadas</label>
                  <input
                    id="wiz-cs-numamort"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="numAccionesAmortizadas"
                    placeholder="Ej: 20"
                  />
                  <small class="wiz-field-hint">Si se amortizan 20 acciones (de la 1 a la 20), informar 20</small>
                </div>

                <div class="column is-12">
                  <label class="label">Numeración acciones amortizadas</label>
                  @for (rango of getReduccionRangos(0).controls; track rango; let j = $index) {
                    <div class="wiz-rango-row" [formGroup]="$any(rango)">
                      <span class="wiz-rango-row__label">De la</span>
                      <input
                        class="search-input wiz-rango-row__input"
                        type="text"
                        pInputText
                        formControlName="desde"
                        placeholder="Nº inicio"
                      />
                      <span class="wiz-rango-row__label">a la</span>
                      <input
                        class="search-input wiz-rango-row__input"
                        type="text"
                        pInputText
                        formControlName="hasta"
                        placeholder="Nº fin"
                      />
                      @if (getReduccionRangos(0).length > 1) {
                        <button
                          type="button"
                          class="wiz-btn-icon wiz-btn-icon--danger"
                          (click)="removeReduccionRango(0, j)"
                          [attr.aria-label]="'Eliminar rango ' + (j + 1)"
                        >
                          <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                      }
                    </div>
                  }
                  <button
                    type="button"
                    class="wiz-btn-text"
                    (click)="addReduccionRango(0)"
                  >
                    + Añadir rango
                  </button>
                </div>
              }

            </div>
          </div>
        </div>
        <!-- Hidden capital component for serie-creation modal -->
        <div class="wiz-capital-modal-host">
          <app-constitution-capital-series-section [clientId]="clientId" [deferPersistence]="true" (seriesChanged)="syncSociosWithCapital()"></app-constitution-capital-series-section>
        </div>
      }

      <!-- ── Objeto Social ──────────────────────────────────────────────── -->
      @if (currentStepKey() === 'objetoSocial' || currentStepKey() === 'escritura' || (isResumen() && (hasStep('objetoSocial') || hasStep('escritura')))) {
        @if (categoria === 'constitucion' || subtipo === 'objeto_social') {
          <!-- Solo CNAE + objeto social (escritura ya está en paso anterior) -->
          <div class="wiz-crosstab-step">
            <h3 class="wiz-section-title">Objeto Social</h3>
            <div class="columns is-multiline">
              <div class="column is-6 form-container">
                <label class="label" for="wiz-cnae">Código CNAE</label>
                <p-dropdown
                  inputId="wiz-cnae"
                  [options]="store.cnaeCodes()"
                  optionLabel="code"
                  optionValue="code"
                  [ngModel]="store.form.get('cnaeCode')?.value"
                  (ngModelChange)="store.form.get('cnaeCode')?.setValue($event)"
                  placeholder="Seleccionar CNAE..."
                  [filter]="true"
                  filterBy="code,title"
                  filterPlaceholder="Buscar CNAE..."
                  appendTo="body"
                  [baseZIndex]="3000"
                  class="search-input"
                >
                  <ng-template let-option pTemplate="item">
                    {{ option.code }} - {{ option.title }}
                  </ng-template>
                  <ng-template let-selected pTemplate="selectedItem">
                    {{ selected?.code }} - {{ selected?.title }}
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="column is-12 form-container">
                <label class="label" for="wiz-objeto-social">Objeto social</label>
                <textarea
                  id="wiz-objeto-social"
                  pInputTextarea
                  [autoResize]="true"
                  class="search-input"
                  [ngModel]="store.form.get('corporateName')?.value"
                  (ngModelChange)="store.form.get('corporateName')?.setValue($event)"
                  rows="5"
                  placeholder="Describe el objeto social de la empresa..."
                ></textarea>
              </div>
            </div>
          </div>
        } @else {
          <app-constitution-deed-object-section></app-constitution-deed-object-section>
        }
      }

      <!-- ── Fusión absorbente ──────────────────────────────────────────── -->
      @if (currentStepKey() === 'step_fusion' || (isResumen() && hasStep('step_fusion'))) {
        <div class="wiz-crosstab-step">
          <h3 class="wiz-section-title">Fusión</h3>

          <div [formGroup]="fusionForm" class="columns is-multiline">
            <div class="column is-6 form-container">
              <label class="label" for="wiz-fusion-tipo">Tipo de fusión</label>
              <p-dropdown
                inputId="wiz-fusion-tipo"
                [options]="[
                  { label: 'Sin ampliación de capital', value: 'sin_ampliacion' },
                  { label: 'Con ampliación de capital', value: 'con_ampliacion' }
                ]"
                optionLabel="label"
                optionValue="value"
                formControlName="tipoFusion"
                placeholder="Seleccionar tipo..."
                appendTo="body"
                [baseZIndex]="3000"
                class="search-input"
                (onChange)="onTipoFusionChange($event.value)"
              ></p-dropdown>
            </div>
          </div>

          @if (selectedTipoFusion() === 'con_ampliacion') {

            <!-- Tipo de ampliación -->
            <h4 class="wiz-subsection-title" style="margin-top: 1.5rem;">Tipo de ampliación</h4>
            <div [formGroup]="ampTipoForm" class="columns is-multiline">
              <div class="column is-6 form-container">
                <label class="label" for="wiz-fusion-amp-tipo">Tipo de ampliación</label>
                <p-dropdown
                  inputId="wiz-fusion-amp-tipo"
                  [options]="tipoAmpliacionOptions"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="tipoAmpliacion"
                  placeholder="Seleccionar tipo..."
                  appendTo="body"
                  [baseZIndex]="3000"
                  class="search-input"
                  (onChange)="onTipoAmpliacionChange($event.value)"
                ></p-dropdown>
              </div>

              <div class="column is-6"></div>

              @if (selectedTipoAmpliacion() === 'no_dineraria') {
                <div class="column is-12 form-container">
                  <label class="label" for="wiz-fusion-aportaciones">Detalle aportaciones</label>
                  <textarea
                    id="wiz-fusion-aportaciones"
                    pInputTextarea
                    [autoResize]="true"
                    class="search-input"
                    formControlName="detalleAportaciones"
                    rows="4"
                    placeholder="Describa las aportaciones no dinerarias..."
                  ></textarea>
                </div>
              }

              @if (selectedTipoAmpliacion() === 'canje_valores') {
                <div class="column is-12 form-container">
                  <label class="label" for="wiz-fusion-canje">Régimen especial Canje de Valores</label>
                  <textarea
                    id="wiz-fusion-canje"
                    pInputTextarea
                    [autoResize]="true"
                    class="search-input"
                    formControlName="detalleCanje"
                    rows="4"
                    placeholder="Detalle del régimen especial de canje de valores..."
                  ></textarea>
                </div>
              }
            </div>

            <!-- Datos de la ampliación -->
            <h4 class="wiz-subsection-title" style="margin-top: 1.5rem;">Ampliación</h4>
            <div [formGroup]="ampDatosForm" class="columns is-multiline">
              <div class="column is-6 form-container">
                <label class="label" for="wiz-fusion-modo">Modo de ampliación</label>
                <p-dropdown
                  inputId="wiz-fusion-modo"
                  [options]="modoAmpliacionOptions"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="modoAmpliacion"
                  placeholder="Seleccionar modo..."
                  appendTo="body"
                  [baseZIndex]="3000"
                  class="search-input"
                  (onChange)="onModoAmpliacionChange($event.value)"
                ></p-dropdown>
              </div>

              <div class="column is-6"></div>

              @if (selectedModoAmpliacion() === 'ampliacion_vn') {
                <div class="column is-12">
                  <h4 class="wiz-subsection-title">Ampliación Valor Nominal</h4>
                </div>
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-fusion-vn-serie">Serie</label>
                  <p-dropdown
                    inputId="wiz-fusion-vn-serie"
                    [options]="seriesOptions()"
                    optionLabel="label"
                    optionValue="value"
                    formControlName="vnSerie"
                    placeholder="Seleccionar serie..."
                    appendTo="body"
                    [baseZIndex]="3000"
                    class="search-input"
                    (onChange)="onSerieChange('vnSerie', $event.value)"
                  ></p-dropdown>
                </div>
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-fusion-vn-importe">Importe ampliado</label>
                  <input
                    id="wiz-fusion-vn-importe"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="vnImporteAmpliado"
                  (input)="recalcNuevoVnAmpliacion()"
                    placeholder="Ej: 1,50 €"
                  />
                  <small class="wiz-field-hint">Diferencia entre el VN antiguo y el nuevo</small>
                </div>
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-fusion-vn-nuevo">Nuevo VN</label>
                  <input
                    id="wiz-fusion-vn-nuevo"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="vnNuevoVN"
                    placeholder="Ej: 2,50 €"
                  />
                  <small class="wiz-field-hint">Valor nominal resultante</small>
                </div>
              }

              @if (selectedModoAmpliacion() === 'ampliacion_acciones') {
                <div class="column is-12">
                  <h4 class="wiz-subsection-title">Ampliación acciones</h4>
                </div>
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-fusion-acc-serie">Serie</label>
                  <p-dropdown
                    inputId="wiz-fusion-acc-serie"
                    [options]="seriesOptions()"
                    optionLabel="label"
                    optionValue="value"
                    formControlName="accSerie"
                    placeholder="Seleccionar serie..."
                    appendTo="body"
                    [baseZIndex]="3000"
                    class="search-input"
                    (onChange)="onSerieChange('accSerie', $event.value)"
                  ></p-dropdown>
                </div>
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-fusion-acc-nuevas">Nuevas acciones</label>
                  <input
                    id="wiz-fusion-acc-nuevas"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="accNuevasAcciones"
                    placeholder="Ej: 5"
                  />
                  <small class="wiz-field-hint">Número de nuevas acciones a emitir</small>
                </div>
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-fusion-acc-desde">De la</label>
                  <input
                    id="wiz-fusion-acc-desde"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="accDesde"
                    placeholder="Nº inicio"
                  />
                </div>
                <div class="column is-4 form-container">
                  <label class="label" for="wiz-fusion-acc-hasta">A la</label>
                  <input
                    id="wiz-fusion-acc-hasta"
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="accHasta"
                    placeholder="Nº fin"
                  />
                </div>
              }
            </div>

            <!-- Hidden capital component for serie-creation modal -->
            <div class="wiz-capital-modal-host">
              <app-constitution-capital-series-section [clientId]="clientId" [deferPersistence]="true" (seriesChanged)="syncSociosWithCapital()"></app-constitution-capital-series-section>
            </div>
          }

        </div>
      }

      <!-- ── Capital Social ─────────────────────────────────────────────── -->
      @if (currentStepKey() === 'capitalSocial' || (isResumen() && hasStep('capitalSocial'))) {
        <app-constitution-capital-series-section [clientId]="clientId" [deferPersistence]="true" (seriesChanged)="syncSociosWithCapital()"></app-constitution-capital-series-section>
      }

      <!-- ── Transmisión de acciones ────────────────────────────────────── -->
      @if (currentStepKey() === 'step_transmision' || (isResumen() && hasStep('step_transmision'))) {
        <div class="wiz-crosstab-step" [formGroup]="transmisionForm">
          <h3 class="wiz-section-title">Transmisión de acciones</h3>

          <div class="columns is-multiline">

            <div class="column is-6 form-container">
              <label class="label" for="wiz-tx-tipo">Tipo de transmisión</label>
              <p-dropdown
                inputId="wiz-tx-tipo"
                [options]="tipoTransmisionOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="tipoTransmision"
                placeholder="Seleccionar tipo..."
                appendTo="body"
                [baseZIndex]="3000"
                class="search-input"
              ></p-dropdown>
            </div>

            <div class="column is-6"></div>

            <div class="column is-6 form-container">
              <label class="label" for="wiz-tx-transmitente">Transmitente (socio ya creado)</label>
              <p-dropdown
                inputId="wiz-tx-transmitente"
                [options]="socioOptions()"
                optionLabel="label"
                optionValue="value"
                formControlName="transmitente"
                placeholder="Seleccionar persona..."
                [filter]="true"
                filterPlaceholder="Buscar..."
                appendTo="body"
                [baseZIndex]="3000"
                class="search-input"
              ></p-dropdown>
              <small class="wiz-field-hint">Solo socios dados de alta en la empresa</small>
            </div>

            @if (transmisionForm.get('transmitente')?.value != null) {
              <div class="column is-12">
                <label class="label">Participaciones del transmitente antes de la transmisión</label>
                <table class="table is-fullwidth is-narrow">
                  <thead>
                    <tr>
                      <th>Serie</th>
                      <th>Título</th>
                      <th>Desde</th>
                      <th>Hasta</th>
                      <th class="has-text-right">Nº acciones</th>
                      <th>Fecha de baja</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of bajaRows; track row; let k = $index) {
                      <tr [formGroup]="row">
                        <td>{{ row.value.serie }}</td>
                        <td>{{ tituloLabel(row.value.titulo) }}</td>
                        <td>{{ fmt(row.value.desde) }}</td>
                        <td>{{ fmt(row.value.hasta) }}</td>
                        <td class="has-text-right">{{ fmt(row.value.count) }}</td>
                        <td>
                          <p-calendar
                            [inputId]="'wiz-tx-baja-' + k"
                            formControlName="fechaBaja"
                            dateFormat="dd/mm/yy"
                            dataType="string"
                            [showIcon]="true"
                            appendTo="body"
                            [baseZIndex]="3000"
                            placeholder="dd/mm/aaaa"
                            [attr.aria-label]="'Fecha de baja participación ' + (k + 1)"
                          ></p-calendar>
                        </td>
                      </tr>
                    } @empty {
                      <tr><td colspan="6">Este socio no tiene acciones numeradas.</td></tr>
                    }
                  </tbody>
                  @if (bajaRows.length > 0) {
                    <tfoot>
                      <tr>
                        <th colspan="4">Total</th>
                        <th class="has-text-right">{{ fmt(bajasTotal) }}</th>
                        <th></th>
                      </tr>
                    </tfoot>
                  }
                </table>
                <small class="wiz-field-hint">Las participaciones con fecha de baja dejan de aparecer en el paso de socios.</small>
              </div>
            }

            @for (adq of adquirentes.controls; track adq; let i = $index) {
              <div class="column is-12" [formGroup]="$any(adq)">
                <div class="wiz-reduccion-entry">
                  <div class="wiz-reduccion-entry__header">
                    <h4 class="wiz-subsection-title">Adquirente {{ i + 1 }}</h4>
                    @if (adquirentes.length > 1) {
                      <button
                        type="button"
                        class="wiz-btn-icon wiz-btn-icon--danger"
                        (click)="removeAdquirente(i)"
                        [attr.aria-label]="'Eliminar adquirente ' + (i + 1)"
                      >
                        <fa-icon [icon]="faTrash"></fa-icon>
                      </button>
                    }
                  </div>

                  <div class="columns is-multiline">
                    <div class="column is-6 form-container">
                      <label class="label" [attr.for]="'wiz-tx-adquirente-' + i">Adquirente</label>
                      <p-dropdown
                        [inputId]="'wiz-tx-adquirente-' + i"
                        [options]="personOptions()"
                        optionLabel="label"
                        optionValue="value"
                        formControlName="adquirente"
                        placeholder="Seleccionar persona..."
                        [filter]="true"
                        filterPlaceholder="Buscar..."
                        appendTo="body"
                        [baseZIndex]="3000"
                        class="search-input"
                      ></p-dropdown>
                      <small class="wiz-field-hint">Personas dadas de alta en la base de datos</small>
                    </div>

                    <div class="column is-6 form-container">
                      <label class="label" [attr.for]="'wiz-tx-num-acc-' + i">Nº acciones vendidas</label>
                      <input
                        [id]="'wiz-tx-num-acc-' + i"
                        class="search-input"
                        type="text"
                        pInputText
                        formControlName="numAccionesVendidas"
                        placeholder="Ej: 50"
                      />
                    </div>

                    <div class="column is-12 form-container">
                      <label class="label">Numeración acciones vendidas</label>
                      @for (rango of getAdquirenteRangos(i).controls; track rango; let j = $index) {
                        <div class="wiz-rango-row" [formGroup]="$any(rango)">
                          <label class="wiz-rango-row__label" [attr.for]="'wiz-tx-serie-' + i + '-' + j">Serie</label>
                          <p-dropdown
                            [inputId]="'wiz-tx-serie-' + i + '-' + j"
                            [options]="existingSeriesOptions()"
                            optionLabel="label"
                            optionValue="value"
                            formControlName="serie"
                            placeholder="Seleccionar serie..."
                            appendTo="body"
                            [baseZIndex]="3000"
                            class="wiz-rango-row__serie"
                          ></p-dropdown>
                          <span class="wiz-rango-row__label">De la</span>
                          <input
                            class="search-input wiz-rango-row__input"
                            type="text"
                            pInputText
                            formControlName="desde"
                            placeholder="Nº inicio"
                            [attr.aria-label]="'Numeración inicio rango ' + (j + 1)"
                          />
                          <span class="wiz-rango-row__label">a la</span>
                          <input
                            class="search-input wiz-rango-row__input"
                            type="text"
                            pInputText
                            formControlName="hasta"
                            placeholder="Nº fin"
                            [attr.aria-label]="'Numeración fin rango ' + (j + 1)"
                          />
                          @if (getAdquirenteRangos(i).length > 1) {
                            <button
                              type="button"
                              class="wiz-btn-icon wiz-btn-icon--danger"
                              (click)="removeTransmisionRango(i, j)"
                              [attr.aria-label]="'Eliminar rango ' + (j + 1)"
                            >
                              <fa-icon [icon]="faTrash"></fa-icon>
                            </button>
                          }
                        </div>
                      }
                      <button type="button" class="wiz-btn-text" (click)="addTransmisionRango(i)">
                        + Añadir rango
                      </button>
                    </div>

                    <div class="column is-6 form-container">
                      <label class="label" [attr.for]="'wiz-tx-prima-' + i">Prima de emisión</label>
                      <input
                        [id]="'wiz-tx-prima-' + i"
                        class="search-input"
                        type="text"
                        pInputText
                        formControlName="primaEmision"
                        placeholder="Ej: 500,00 €"
                      />
                    </div>

                    <div class="column is-6 form-container">
                      <label class="label" [attr.for]="'wiz-tx-precio-' + i">Precio / Valor de la transmisión</label>
                      <input
                        [id]="'wiz-tx-precio-' + i"
                        class="search-input"
                        type="text"
                        pInputText
                        formControlName="precioTransmision"
                        placeholder="Ej: 10.000,00 €"
                      />
                    </div>
                  </div>
                </div>
              </div>
            }

            <div class="column is-12">
              <button type="button" class="wiz-btn-text" (click)="addAdquirente()">
                + Añadir adquirente
              </button>
            </div>

          </div>
        </div>
      }

      <!-- ── Socios ─────────────────────────────────────────────────────── -->
      @if (currentStepKey() === 'socios' || (isResumen() && hasStep('socios'))) {
        <app-constitution-socios-section
          [clientId]="clientId"
          [activeTab]="'constitution'"
          [deferPersistence]="true"
        ></app-constitution-socios-section>
      }

      <!-- ── Administración ─────────────────────────────────────────────── -->
      @if (currentStepKey() === 'administracion' || (isResumen() && hasStep('administracion'))) {
        <app-constitution-administration-section
          [clientId]="clientId"
          [activeTab]="'constitution'"
          [deferPersistence]="true"
        ></app-constitution-administration-section>
      }

      <!-- ── Apoderados ─────────────────────────────────────────────────── -->
      @if (currentStepKey() === 'apoderados' || (isResumen() && hasStep('apoderados'))) {
        <app-constitution-representatives
          [clientId]="clientId"
          [activeTab]="'constitution'"
          [deferPersistence]="true"
        ></app-constitution-representatives>
      }

      <!-- ── Transformación: Identificación (misma UI que pestaña cliente) ── -->
      @if (isTransformacion) {
        <div
          class="wiz-crosstab-step"
          [hidden]="currentStepKey() !== 'step_transformacion' && !isResumen()"
        >

          @if (tabAfectada) {
            <div class="wiz-crosstab-note" role="note">
              <span class="wiz-crosstab-note-pill">Pestaña {{ tabAfectada.label }}</span>
              <span class="wiz-crosstab-note-text">{{ tabAfectada.accion }}</span>
            </div>
          }

          <app-identification-form
            #identificationStep
            [clientId]="clientId"
            [hasEditPermission]="true"
            [deferPersistence]="true"
            [hidePersistenceUi]="true"
            [corporateOperationOverlay]="identificationOperationOverlay"
            (corporateOperationPayloadChange)="onIdentificationPayload($event)"
          ></app-identification-form>
        </div>
      }

      <!-- ── Resumen: los pasos anteriores se renderizan arriba con isResumen() ── -->

    </div>

    <!-- ── Footer ─────────────────────────────────────────────────────── -->
    @if (showStepErrors() && stepErrors.length > 0) {
      <div class="wiz-save-error" role="alert" data-testid="wiz-step-errors">
        @for (err of stepErrors; track err) {
          <div>{{ err }}</div>
        }
      </div>
    }

    @if (saveError()) {
      <div class="wiz-save-error" role="alert" data-testid="wiz-save-error">{{ saveError() }}</div>
    }

    <footer class="wiz-footer">
      <button
        type="button"
        class="button is-primary is-outlined wiz-btn-prev"
        [disabled]="isFirstStep()"
        (click)="prev()"
      >
        Anterior
      </button>

      @if (!isLastStep()) {
        <button
          type="button"
          class="button is-secondary wiz-btn-next"
          (click)="next()"
        >
          Siguiente
        </button>
      } @else {
        <button
          type="button"
          class="button is-secondary wiz-btn-finish"
          [disabled]="isSaving()"
          (click)="finish()"
        >
          @if (isSaving()) {
            Guardando...
          } @else {
            Finalizar
          }
        </button>
      }
    </footer>

    } <!-- end @if (!isInitializing()) -->

</div>
